var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { gql, useQuery } from '@apollo/client';
import { DateFormats, } from '../../contracts/types';
export const REVIEWS_PAGE_SIZE = 5;
const HOTEL_REVIEWS_RESULTS_QUERY = gql `
    query GetReviews($estabId: Int!, $request: ReviewsRequest, $format: DateFormats) {
        getEstabById(estabId: $estabId) {
            estabId
            reviews(request: $request) {
                checkInDate(format: $format)
                comment
                id
                rating
                ratingFormatted
                reviewerLocation
                reviewerName
            }
        }
    }
`;
export function useHotelReviewsResults(estabId, countryCode) {
    const _a = useQuery(HOTEL_REVIEWS_RESULTS_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        variables: {
            estabId: parseInt(estabId),
            request: {
                countryCode,
                pagination: {
                    limit: REVIEWS_PAGE_SIZE,
                    offSet: 0,
                },
            },
            format: DateFormats.Default,
        },
    }), { data, fetchMore } = _a, others = __rest(_a, ["data", "fetchMore"]);
    const fetchNext = () => {
        var _a, _b;
        fetchMore({
            variables: {
                estabId: parseInt(estabId),
                request: {
                    countryCode,
                    pagination: {
                        limit: REVIEWS_PAGE_SIZE,
                        offSet: Math.floor((((_b = (_a = data === null || data === void 0 ? void 0 : data.getEstabById) === null || _a === void 0 ? void 0 : _a.reviews) === null || _b === void 0 ? void 0 : _b.length) || 0) / REVIEWS_PAGE_SIZE),
                    },
                },
                format: DateFormats.Default,
            },
        });
    };
    return [Object.assign({ data, fetchMore }, others), fetchNext];
}
